export default "__VITE_ASSET__CcIXxzD1__"